import {
  Dialog,
  DialogActions,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Button,
} from '@eye-able/ui';
import { useAtom } from 'jotai';
import { demoModeAtom, showFaceliftWelcomeBannerAtom } from '@/global-store';
import { assetUrl } from '@helpers/assetUrl';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { T } from '@/i18n/T';

export const FaceliftWelcomeBanner = () => {
  const [show, setShow] = useAtom(showFaceliftWelcomeBannerAtom);
  const [demoMode] = useAtom(demoModeAtom);
  const { t, i18n } = useInlineTranslation();

  const suffix = i18n.resolvedLanguage === 'de' ? '.de' : '';

  if (!show || demoMode) {
    return null;
  }

  return (
    <Dialog defaultOpen={true}>
      <DialogContent persistent={true}>
        <DialogTitle><T k='faceliftWelcomeBannerTitle' /></DialogTitle>
        <DialogDescription>
          <div className='eye:flex eye:flex-col eye:gap-y-16'>
            <img
              className='eye:mb-8'
              alt={t('faceliftWelcomeBannerAltText')}
              src={assetUrl(`faceliftWelcomeApplication${suffix}.png`)}
            />
            <h1 className='eye:font-bold eye:flex eye:items-center eye:justify-center eye:gap-12'>
              <span role='img' aria-hidden className='eye:text-42'>
                🥳
              </span>
              <T k='faceliftWelcomeBannerText1' />
            </h1>
            <p>
              <strong><T k='faceliftWelcomeBannerText2' /></strong>
              <br />
              <T k='faceliftWelcomeBannerText3' />
            </p>
            <div>
              <strong><T k='faceliftWelcomeBannerText4' /></strong>
              <ul className='eye:list-disc eye:pl-16'>
                <li className='eye:list-outside'>
                  <T k='faceliftWelcomeBannerText5' />
                </li>
                <li className='eye:list-outside'>
                  <T k='faceliftWelcomeBannerText6' />
                </li>
              </ul>
            </div>
          </div>
        </DialogDescription>
        <DialogActions>
          <DialogClose asChild>
            <Button onClick={() => setShow(false)} variant='yellow'>
              <T k='faceliftWelcomeBannerButton' />
            </Button>
          </DialogClose>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
